__turbopack_context__.v({
  "numberInputButton": "NumberInput-module-scss-module__u5k7aG__numberInputButton",
  "numberInputButtonCondensed": "NumberInput-module-scss-module__u5k7aG__numberInputButtonCondensed",
  "numberInputField": "NumberInput-module-scss-module__u5k7aG__numberInputField",
  "numberInputFieldCondensed": "NumberInput-module-scss-module__u5k7aG__numberInputFieldCondensed",
  "numberInputRoot": "NumberInput-module-scss-module__u5k7aG__numberInputRoot",
});
